module.exports = __webpack_public_path__ + "static/media/bird-rooster1.661607c7.aac";